import React from "react";
import {
  validatePartnerRoleType,
  validateDashboardFilter,
} from "../../utils/common";
import FormControl from "../../components/formControl";
import { Button } from "@material-ui/core";
import CustomDropDown from "../../components/presentationals/CustomDropdown";
import { Skeleton } from "@mui/material";
import { useSelector } from "react-redux";
import Tooltip from "@mui/material/Tooltip";

const DashboardFilterView = (props) => {
  const {
    partnerRoleType,
    // homeReducer.selectedOptionData,
    component,
    isChild,
    subComponent,
    showCategory,
    filteredArray,
    showDropdown,
    changeHandler,
    runButtonClickHandler,
    getSchemeOptionDisabled,
  } = { ...props };
  const { homeReducer } = useSelector((state) => state);

  // console.log("filtered array=> ", filteredArray);

  let isVisibleForPartner = validatePartnerRoleType(partnerRoleType);
  let partner = "PARTNER";
  let isEnableRunButton = true;
  if (!isVisibleForPartner.businessType && component === "payout") {
    if (
      partnerRoleType === "ZD" ||
      partnerRoleType === "ZDMT" ||
      partnerRoleType === "ITZ"
    ) {
      partner = "ZD";
    } else if (partnerRoleType === "DT" || partnerRoleType === "END") {
      partner = "END";
    } else if (partnerRoleType === "XG") {
      partner = "XG";
    } else {
      partner = "RDS";
    }
  }
  let RoleType = !isVisibleForPartner.businessType ? partner : partnerRoleType;
  let currSelected =
    homeReducer.selectedOptionData &&
    homeReducer.selectedOptionData["ZD/ZDMT/ARD/MARD"] &&
    homeReducer.selectedOptionData["ZD/ZDMT/ARD/MARD"].split(" - ")[0];

  return (
    <div className="whitebox mt-sm-5 mb-1">
      <form autoComplete="off">
        {validateDashboardFilter(
          RoleType,
          component,
          showCategory,
          isChild,
          currSelected,
          subComponent
        ).map((data, index) => {
          if (data.type === "form") {
            if (
              data?.name === "Scheme Type"
                ? homeReducer.selectedOptionData["Scheme_Type"]?.schemeType
                : data.name === "Scheme Name"
                ? homeReducer.selectedOptionData["Scheme"]
                : homeReducer.selectedOptionData[data.name]
            ) {
              isEnableRunButton &= true;
            } else {
              isEnableRunButton &= false;
            }
          }
          return (
            <FormControl
              key={index}
              variant={data.variant}
              type={data.type}
              styleName={data.className}
            >
              {data.type === "form" ? (
                (
                  filteredArray[
                    data.name === "Scheme Type"
                      ? "Scheme_Type"
                      : data.name === "Scheme Name"
                      ? "Scheme"
                      : data.name
                  ]
                    ? false
                    : true
                ) ? (
                  <Skeleton variant="rectangular" height={40} />
                ) : (
                  <CustomDropDown
                    name={data.name}
                    data={
                      filteredArray &&
                      filteredArray[
                        data.name === "Scheme Type"
                          ? "Scheme_Type"
                          : data.name === "Scheme Name"
                          ? "Scheme"
                          : data.name
                      ]
                    }
                    loading={
                      filteredArray[
                        data.name === "Scheme Type"
                          ? "Scheme_Type"
                          : data.name === "Scheme Name"
                          ? "Scheme"
                          : data.name
                      ]
                        ? false
                        : true
                    }
                    changeHandler={(value) =>
                      changeHandler(
                        value,
                        data.name === "Scheme Type"
                          ? "Scheme_Type"
                          : data.name === "Scheme Name"
                          ? "Scheme"
                          : data.name,
                        homeReducer
                      )
                    }
                    getOptionDisabled={
                      data.name === "Scheme Name" && getSchemeOptionDisabled
                        ? getSchemeOptionDisabled
                        : undefined
                    }
                    value={
                      data?.name === "Scheme Type"
                        ? homeReducer.selectedOptionData["Scheme_Type"]
                            ?.schemeType
                        : data.name === "Scheme Name"
                        ? homeReducer.selectedOptionData["Scheme"]
                        : homeReducer.selectedOptionData[data.name]
                    }
                    showDropdown={showDropdown}
                  />
                )
              ) : isEnableRunButton ? (
                <Button
                  // className="mt-2"
                  style={{ height: "40px" }}
                  onClick={(e) => runButtonClickHandler(e)}
                  variant="contained"
                  color="default"
                >
                  Run
                </Button>
              ) : (
                <Tooltip
                  title="Run button will be disabled if no data is available for the selected date"
                  placement="top"
                  arrow
                >
                  <span>
                    <Button
                      // className="mt-2"
                      style={{ height: "40px" }}
                      onClick={(e) => runButtonClickHandler(e)}
                      variant="contained"
                      color="default"
                      disabled
                    >
                      Run
                    </Button>
                  </span>
                </Tooltip>
              )}
            </FormControl>
          );
        })}
      </form>
    </div>
  );
};

export default DashboardFilterView;
